import { ContentKey } from "./steps";

export enum RedirectOptions {
  WINDOWS = 'windows',
  LINUX = 'linux',
  MACOS = 'mac',
  DOWNLOAD_PIP = 'downloadpip',
  MSSQL_SCRIPTER_WINDOWS = 'mssql-scripter-windows',
  MSSQL_SCRIPTER_LINUX = 'mssql-scripter-linux',
  MSSQL_SCRIPTER_MACOS = 'mssql-scripter-macos',
  DOWNLOAD_POETRY = 'download_poetry',
  AWS_CLI_INSTALL = 'aws-cli-install',
  AWS_CLI_S3_CONFIG = 'aws-cli-s3-config',
  UNKNOWN = 'unknown',
}

export type RedirectLink = {
  key: RedirectOptions;
  value: string;
};

export const redirectLinksMock: RedirectLink[] = [
  {
    key: RedirectOptions.WINDOWS,
    value: 'https://www.python.org/downloads/windows/',
  },
  {
    key: RedirectOptions.LINUX,
    value: 'https://www.python.org/downloads/source/',
  },
  {
    key: RedirectOptions.MACOS,
    value: 'https://www.python.org/downloads/macos/',
  },
  {
    key: RedirectOptions.DOWNLOAD_PIP,
    value: 'https://pip.pypa.io/en/stable/installation/',
  },
  {
    key: RedirectOptions.MSSQL_SCRIPTER_WINDOWS,
    value: 'https://github.com/microsoft/mssql-scripter/blob/dev/doc/installation_guide.md#windows-installation',
  },
  {
    key: RedirectOptions.MSSQL_SCRIPTER_LINUX,
    value: 'https://github.com/microsoft/mssql-scripter/blob/dev/doc/installation_guide.md#linux-installation',
  },
  {
    key: RedirectOptions.MSSQL_SCRIPTER_MACOS,
    value: 'https://github.com/microsoft/mssql-scripter/blob/dev/doc/installation_guide.md#macos-installation',
  },
  {
    key: RedirectOptions.DOWNLOAD_POETRY,
    value: 'https://python-poetry.org/docs/#installation',
  },
  {
    key: RedirectOptions.UNKNOWN,
    value: 'https://www.python.org/downloads/',
  },
  {
    key: RedirectOptions.AWS_CLI_INSTALL,
    value:
      'https://docs.aws.amazon.com/cli/latest/userguide/getting-started-install.html',
  },
  {
    key: RedirectOptions.AWS_CLI_S3_CONFIG,
    value: 'https://docs.aws.amazon.com/cli/latest/topic/s3-config.html',
  },
];
